<template>
  <b-row>
    <b-col cols="12">
      <v-select v-if="templates != null" v-model="selected" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="templateTitle" :options="templates" class="select-size-lg">
        <template #option="{ templateTitle }">
          <span> {{ templateTitle }}</span>
        </template>
      </v-select>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },
  created() {
    this.fetchMailTemplates()

  },
  props: {
    initialTemplate: {
      type: Object,
      default: () => {}
    }
  },


  methods: {
    updateSelections(a) {

      //console.log(a)
    },
    fetchMailTemplates() {
      //console.log("fetchMailTemplates fetch");
      return new Promise((resolve, reject) => {
        axios
          .get('/admin/f/clientmailtemplates')
          .then((response) => {
            var data = response.data;
            var responseData = JSON.parse(JSON.stringify(data));
            this.templates = responseData.data;
          }
          )
          .catch(error => reject(error))
      })
    },
  },
  watch: {
    selected: function (newVal, coldVal) {
      this.$emit("selectionChanged", newVal);

    }
  },
  data() {
    return {
      templates: null,
      selected: this.initialTemplate,
    }
  }


}
</script>